// src/plugins/store.js
import { createStore } from 'vuex'
import { useRouter } from 'vue-router'
import myApi from './axios'        // <- tu axios instance (con withCredentials habilitado)
import idb from './idb'
import { recaptchaPost } from '@/utils/recaptcha'

const router = useRouter()

const store = createStore({
  state () {
    return {
      count: 0,
      dats: [],
      user: JSON.parse(localStorage.getItem('user') || 'null'), // opcional: rehidratar
      bootstrapped: false,   // sabemos si ya consultamos sesión al back
       perfilQuery: null,
    }
  },
  
  mutations: {
    increment (state) { state.count++ },
    setUser(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user)) // opcional
      } else {
        localStorage.removeItem('user')
      }
    },
    setBootstrapped(state, val) { state.bootstrapped = !!val },
    setPerfilQuery(state, query) { 
    state.perfilQuery = query ? { ...query } : null
  },
  },
  
  actions: {
    savePerfilQuery({ commit }, query) {
      commit('setPerfilQuery', query)
    },
    restorePerfilQuery({ state }) {
      return state.perfilQuery
    },

    // Llamar una vez al arrancar la app (ej: en App.vue mounted o en el guard del router)
    async bootstrapSession({ state, commit }) {
      // 1) Rehidrata primero desde localStorage para evitar “logout visual” al refrescar
      if (state.user) commit('setUser', state.user)
        commit('setBootstrapped', true)

      // 2) Verifica en segundo plano con el back. Solo limpia si es 401 (logout real).
      try {
        const { data } = await myApi.post(
          'ecommerce/only_show_profile',
          {},
          { _skipEncryption: true }
        )
        const user = data?.client ?? data?.user ?? null
        if (user) commit('setUser', user)
        } catch (e) {
      if (e?.response?.status === 401) {
        // Sesión inválida real -> limpia
        commit('setUser', null)
      }
      // 404/500/timeouts/CORS: NO limpiar para no simular logout
    }
  },
  
  async clearClientData({ dispatch }) {
  try {
    await dispatch('deleteDat', 'c')
  
  } catch (err) {
    // console.warn('Error deleting IDB "c":', err)
  }
  // Si usas más claves locales, bórralas aquí:
  // try { localStorage.removeItem('cart') } catch (e) {}
  // try { localStorage.removeItem('wishlist') } catch (e) {}
  },
    // Login: el back setea la cookie HttpOnly; aquí solo guardas el usuario
    async login({ commit }, { email, password, CARTS = [], executeRecaptcha }) {
       if (!executeRecaptcha) {
      throw new Error('reCAPTCHA no está disponible')
    }
      const payload = { email, password, CARTS }
      // const { data } = await myApi.post('ecommerce/login', payload)
      const {data} = await recaptchaPost(
                    executeRecaptcha,
                    "login",
                    "ecommerce/login", 
                    payload
                );
      commit('setUser', data.user || null)
      return true
    },

 async logout({ commit, dispatch }) {
  try {
    await myApi.post('logout', {}) 
  } catch (e) {
    console.debug('Logout request failed', e)
  } finally {
    try {
      await dispatch('clearClientData')
    } catch(e) {console.log(e)}
    commit('setUser', null)
    
  }
},

    // utilidades que ya tenías
    async deleteDat(context, name='c') { await idb.deleteDat(name) },
    async getDats(context, name='c') {
      context.state.dats = []
      const dats = await idb.getDats(name)
      dats.forEach(c => context.state.dats.push(c))
    },
    async saveDat(context, data) { await idb.saveDat(data.dat, data.name) },

    // Compatibilidad con tu UI actual
    authLogin() {
      if (this.state.user) router.push({ name: 'Home' })
    },
  },


  getters: {
    loggedIn(state) {
      // Si hay user en memoria => sesión activa (proviene del back al validar cookie)
      return !!state.user
    },
  },
})

export default store
